/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_BurnInputs */

const en_us2_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burning`)
};

const pt_br2_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queimação`)
};

const es_419_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ardor`)
};

const pt_pt2_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ardor`)
};

const fr_fr2_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brûlure`)
};

const de_de2_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brennen`)
};

const it_it2_workout_after_pain_burn = /** @type {(inputs: Workout_After_Pain_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruciore`)
};

/**
* | output |
* | --- |
* | "Burning" |
*
* @param {Workout_After_Pain_BurnInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_burn = /** @type {((inputs?: Workout_After_Pain_BurnInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_BurnInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_burn(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_burn(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_burn(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_burn(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_burn(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_burn(inputs)
	return en_us2_workout_after_pain_burn(inputs)
});
export { workout_after_pain_burn as "workout-after.pain_burn" }